import script from "./ResultScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultScreen.vue?vue&type=script&setup=true&lang=ts"

import "./ResultScreen.vue?vue&type=style&index=0&id=0656f206&scoped=true&lang=css"
import "./ResultScreen.vue?vue&type=style&index=1&id=0656f206&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0656f206"]])

export default __exports__